export default "__VITE_ASSET__Cu3$2ewy__"